export const defaultWiggleOptions = {
  x: 5,
  y: 5,
  extend: true,
};
